import { render, staticRenderFns } from "./LayananForm.vue?vue&type=template&id=c2f23ac0&"
import script from "./LayananForm.vue?vue&type=script&lang=js&"
export * from "./LayananForm.vue?vue&type=script&lang=js&"
import style0 from "./LayananForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports